import React from 'react'
import { Route, Switch } from 'react-router-dom'
import routes from '../../routes'
import { AreaOfInterestSelection } from './AreaOfInterestSelection'
import { CategorySelection } from './CategorySelection'
import { PresentationContainer, VideoPresentationContainer } from './PresentationContainer'

export default function OnDemandPage() {
  return (
    <>
      <Switch>
        <Route exact path={routes.onDemand} render={(props) => <CategorySelection {...props} />} />
        {/* <Route exact path={routes.onDemandPoster} render={(props) => <AreaOfInterestSelection {...props} />} />
        <Route exact path={routes.onDemandVideo} render={(props) => <AreaOfInterestSelection {...props} />} />

        <Route exact path="/on-demand/poster/:abstractId" render={(props) => <PresentationContainer {...props} />} />
        <Route exact path="/on-demand/video/:abstractId" render={(props) => <VideoPresentationContainer {...props} />} /> */}
      </Switch>
    </>
  )
}
